import { SxProps, Theme } from "@mui/material";

export const scheduleSelectSx: SxProps<Theme> = (theme: Theme) => ({
  width: "100%",
  "&&.MuiInputBase-root": { minHeight: 30 },
  "&& .MuiSelect-select": theme.typography.caption,
});

export const scheduleDateFieldSx: SxProps<Theme> = (theme: Theme) => ({
  flex: 1,
  minWidth: 0,
  "&& .MuiInputBase-root": { minHeight: 30, height: 30 },
  "&& .MuiInputBase-input": theme.typography.caption,
  "&& button": { height: 20, minHeight: 20, minWidth: 20, padding: 0, width: 20, margin: 0 },
  "&& button svg": { height: 16, width: 16 },
});

export const scheduleRowItemSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  flexShrink: 0,
  minHeight: 30,
};

export const SCHEDULE_TOOLTIP_SLOT_PROPS = {
  tooltip: {
    sx: (theme: Theme) => ({ width: 200, textAlign: "center", "&&": theme.typography.caption }),
  },
} as const;
